//TODO_CWP: add/fix this modal to match the design
import Icon from '@Components/generic/icon';
import { Actions, AppContext } from "@Context/common/general/context";
import { AnalyticsEvents } from "@Enums";
import { faEnvelopeSquare, faRedoAlt, faSignOutAlt } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Alert, Button, Collapse, Dialog, Stack, Typography, useTheme } from "@mui/material";
import * as Sentry from "@sentry/react";
import { User } from 'firebase/auth';
import React, { useState } from "react";
import ConfirmationDialog from "../common/confirmation-dialog";
import { Parm0Callback } from "../members/teamInterfaces";

const EmailNotVerifiedMessage = ({
  onLogout = ()=>{},
  } : {
  onLogout: Parm0Callback
}) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const { state, dispatch } = React.useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState<string | React.ReactElement>("");
  const [showReportButton, setShowReportButton] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string | React.ReactElement>("");
  const [showIssues, setShowIssues] = useState<boolean>(false);
  const [showReported, setShowReported] = useState<boolean>(false);
  const [counter, setCounter] = useState<number>(0);

  const handleRefreshAccount = () => {
    setCounter(counter + 1);
    setShowReportButton(false);
    setErrorMessage("");
    setSuccessMessage("");
    dispatch({
      type: Actions.FirebaseActions.ReloadUser,
      // Send email verified event
      onSuccess: (currentUser: User) => {
        if(currentUser.emailVerified) {
          dispatch({type: Actions.AppActions.AnalyticsEvent, payload: {
            type: AnalyticsEvents.email_verified
          }});
        } else if(counter >= 3) {
          setErrorMessage("Account not verified");
          setShowReportButton(true);
        } else {
          setErrorMessage("Account not verified")
        }
      }
    });
  };

  const handleSendVerifyEmail = () => {
    setCounter(counter + 1);
    setErrorMessage('');
    setSuccessMessage('');
    dispatch({
      type: Actions.AuthActions.SendStandaloneEmailVerification,
      payload: {
          email: state.user.email
      },
      onSuccess: ()=> {
        setErrorMessage("");
        setSuccessMessage("A new verification has been sent")
      },
      onError: () => {
        setErrorMessage('Please wait a moment before requesting another verification')
      }
    });
  };

  const handleSendReport = () => {
    setShowReported(true);
    console.log("Sending error report");

    Sentry.captureEvent({
      message: "verify email failure reported",
      user: {
        user_id: state.user.id
      },
      extra: { 
        email: state.user.email 
      }
    });

    dispatch({
      type: Actions.AppActions.AnalyticsEvent, 
      payload: {
        type: AnalyticsEvents.verify_email_reported_missing,
        data: {
          email: state.user.email,
          user_id: state.user.id
        }
      }
    });
  }

  return (
    <Dialog
      id="email-not-verified-dialog"
      open={true}
      disableEscapeKeyDown={true}
      PaperProps={{
        sx: { 
          maxWidth: theme.spacing(50),
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          padding: theme => `${theme.spacing(4)} ${theme.spacing(4)}`,
        },
      }}
    >
      <Collapse in={errorMessage != ""} sx={{marginBottom: theme.spacing(1)}}>
        <Alert 
          id="email-not-verified-error-message"
          variant="filled" 
          severity="error" 
          sx={{ 
            color: theme.palette.dsDestructive.v400, 
            backgroundColor: theme.palette.dsDestructive.v200
          }}
          action={ showReportButton && <Button variant="contained" size="small" color="error" 
          onClick={()=> {
            setShowIssues(true);
          }}>Didn't get an email?</Button>}>
          {errorMessage}
        </Alert>
      </Collapse>

      <Collapse in={successMessage != ""} sx={{marginBottom: theme.spacing(1)}}>
        <Alert id="email-not-verified-success-message" variant="filled" severity="success" sx={{ 
          color: theme.palette.success.contrastText, 
          backgroundColor: theme.palette.success.light,
        }}>
          {successMessage}
          </Alert>
      </Collapse>

      <Stack spacing={2}>
        <Typography variant={"h6"}>
          {i18n('signin.verify.email.heading')}
        </Typography>

        <Typography variant={"body1"}>
          {i18n('signin.verify.email.body.1')}
        </Typography>
        <Typography variant="body1">
          {i18n('signin.verify.email.body.2')}
        </Typography>

        <Button id="email-not-verified-refresh-button" fullWidth onClick={handleRefreshAccount} color="primary" variant="contained" sx={{
          display: 'flex',
          }}>
          <Icon icon={faRedoAlt} sx={{
            fontSize: theme.spacing(3),
            marginRight:theme=> theme.spacing(1)
          }}/>
          {i18n('signin.verify.refresh')}
        </Button>

        <Stack direction='row' spacing={2} justifyContent='center'>
          <Button id="email-not-verified-send-email-button" onClick={handleSendVerifyEmail} color="primary" sx={{ lineHeight: 'inherit'}}>
            <Icon icon={faEnvelopeSquare} sx={{
                fontSize: theme.spacing(3),
              marginRight:theme=> theme.spacing(1)
            }}/>
            {i18n('signin.verify.email.button')}
          </Button>
          <Button id="email-not-verified-sign-out-button" onClick={onLogout} color="primary" sx={{ lineHeight: 'inherit'}}>
            <Icon icon={faSignOutAlt} sx={{
              fontSize: theme.spacing(3),
              marginRight:theme=> theme.spacing(1)
            }}/>
            {i18n('button.sign.out')}
          </Button>
        </Stack>
      </Stack>
      {/* Reported Dialog */}
      <ConfirmationDialog
        open={showReported}
        title={'Report Submitted'}
        message={'We have recorded the issue and one of our admins will look into problem for you.'}
        disableCancel={true}
        onConfirm={()=>{
          setShowReported(false);
          setErrorMessage("");
          setSuccessMessage("");
        }}
        confirmLabel={i18n('button.close')}
      >
        <>
        <Typography variant='body1'>Alternatively you can try to register with an another email provider.</Typography>
        <Typography variant='body1'>We apologize for any inconvenience</Typography>
        </>
      </ConfirmationDialog>
      {/* Issues Dialog */}
      <ConfirmationDialog
        open={showIssues}
        title={"Haven't received an email?"}
        message={'Sometimes the email can end up going into the Spam / Junk folders. Please check your Spam folder or email filtering.'}
        // disableCancel={true}
        onCancel={() => {
          // setShowIssues(false);
          setShowIssues(false);
          setErrorMessage("");
          setSuccessMessage("");
        }}
      
        confirmLabel={i18n('Report Issue')}
        onConfirm={()=>{
          setShowIssues(false);
          setShowReported(true);
          setErrorMessage("");
          setSuccessMessage("");
          handleSendReport();
        }}
        buttonProps={[{
          variant: 'contained',
          size: 'small',
          color: 'warning'
        },{
          variant: 'text',
          size: 'small'
        }]}
      >
        <>
        <Typography variant='body1'>Still having issues, please submit a report.</Typography>
        </>
      </ConfirmationDialog>
    </Dialog>
  );
};

export default EmailNotVerifiedMessage;